import type { LobbyRoom } from "./types";

const LOBBY_CATALOG_URL = import.meta.env.VITE_LOBBY_URL as string | undefined;

export async function fetchLobbyRooms(): Promise<LobbyRoom[]> {
  const response = await fetch(LOBBY_CATALOG_URL || "", {
    credentials: "omit",
    cache: "no-store",
  });

  if (!response.ok) {
    throw new Error(`lobby catalog: HTTP ${response.status}`);
  }

  const { rooms } = await response.json();
  if (!Array.isArray(rooms)) {
    throw new Error("lobby catalog: в ответе нет массива rooms");
  }

  return rooms;
}

export const buildRoomSocketUrl = (room: LobbyRoom): string =>
  `${room.webSocketUrl}?roomId=${room.roomId}`;
